import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

import RouteNameConstants from "../constants/route-name-constants";
import { oneOrBothTrue } from "../utils/promise.utils";
import { AuthService } from "./auth.service";

@Injectable()
/**
 * Special guard for `Admin` or `CountryAdmin` roles, since in our
 * AdminGuard or CountryAdmin guards do not simply return `boolean`
 * but has also side effect to navigation to `No Access` page, we have
 * a guard to handle case user either or `Admin` either `CountryAdmin`.
 */
export class AdminOrCountryAdminAuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate() {
    return oneOrBothTrue(
      this.authService.isAdminGroupProfileAsync(),
      this.authService.isCountryAdminAsync(),
    ).then((x) => {
      if (!x) {
        this.router.navigate([RouteNameConstants.NO_ACCESS]);
      }
    });
  }
}
